import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import { apiClient, apiErrorMessage } from '../../../utils';

export function NewRolePage(props: { onSaved: () => void }) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    apiClient
      .post('roles', values)
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} name="basic" onFinish={onFinish}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { pattern: /^[a-zA-Z0-9ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/, message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir' },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Açıklama"
        name="description"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 400, message: 'En fazla 400 karakter' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 6, span: 18 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Ekle
        </Button>
      </Form.Item>
    </Form>
  );
}
